import { Link } from 'react-router-dom'

const NotFound = () => (
  <>
    Sorry, looks like we&apos;ve sent you the wrong way. <Link to="/">Go Home</Link>.
  </>
)

export default NotFound
